import { CalendarEventResponseStatus } from '@griply/types';

const STATUS_LABEL_KEYS: Record<CalendarEventResponseStatus, string> = {
  [CalendarEventResponseStatus.Accepted]:
    'forms.event.fields.guests.status.accepted',
  [CalendarEventResponseStatus.Declined]:
    'forms.event.fields.guests.status.declined',
  [CalendarEventResponseStatus.Tentative]:
    'forms.event.fields.guests.status.tentative',
  [CalendarEventResponseStatus.NeedsAction]:
    'forms.event.fields.guests.status.needs-action',
};

// a status this build doesn't know (newer backend) reads as "no answer yet", never blank
export const getCalendarEventGuestStatusLabelKey = (
  status: CalendarEventResponseStatus,
): string =>
  STATUS_LABEL_KEYS[status] ??
  STATUS_LABEL_KEYS[CalendarEventResponseStatus.NeedsAction];
